import React, { useState, useEffect } from 'react';
import { Button, Dialog, Box, makeStyles, Grid, DialogTitle, DialogContent } from '@material-ui/core';
import GridContainer from '../../../../../@jumbo/components/GridContainer';
import { CORP_BLUE } from 'config/config';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ViewHistoriaSuper from '../AddAntecedente/ViewHistoriaSuper';
import ViewHistoriaPrestador from '../AddAntecedente/ViewHistoriaPrestador';
import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import { obtenerAdjuntosIfPorFolio } from 'services/api';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    backgroundColor: CORP_BLUE,
    '& .MuiTypography-h6': {
      fontSize: 16,
      /* color: theme.palette.common.dark, */
      color: 'white',
      fontFamily: 'Roboto',
    },
  },
  num: {
    display: 'block',
    width: '100%',
    fontFamily: 'Roboto',
  },
  date: {
    display: 'block',
    width: '100%',
    color: 'white',
    fontWeight: 100,
    fontSize: 'small',
    fontFamily: 'Roboto',
  },
  type: {
    display: 'block',
    width: '100%',
    color: 'white',
    fontWeight: 100,
    fontSize: 'small',
    fontFamily: 'Roboto',
  },
}));

const defaultReclamo = {
  num: '',
  fechaIngreso: '',
  tipo: '',
  reclamante: '',
  Rut: '',
  Etapa: '',
  materia: '',
  via: '',
  region: '',
  comuna: '',
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: 3 }} style={{ minHeight: 370 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const VerReclamo = props => {
  const { openDialog = false, close, reclamo = defaultReclamo, cargarPreview, cargarPreviewSuper } = props;
  const classes = addStyle();
  const [num, setNum] = useState('');
  const [fecha, setFecha] = useState(false);
  const [etapa, setEtapa] = useState(false);
  const [nombreCompleto, setNombreCompleto] = useState(false);
  const [nombrePac, setNombrePac] = useState(false);
  const [runPac, setRunPac] = useState(false);
  const [prevPac, setPrevPac] = useState(false);
  const [rut, setRut] = useState(false);
  const [materia, setMateria] = useState(false);
  const [subMateria, setSubMateria] = useState('');
  const [via, setVia] = useState(false);
  /*   const [region, setRegion] = useState(false);
  const [comuna, setComuna] = useState(false); */
  const [loading, setLoading] = useState(true);

  const [value, setValue] = React.useState(0);

  const [adjuntosPrestador, setAdjuntosPrestador] = useState([]);

  /*   const solicitatres = [{ nombre: 'nom1' }, { nombre: 'nom2' }, { nombre: 'nom3' }]; */

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (reclamo) {
      setNum(reclamo.n_reclamo ? reclamo.n_reclamo : 'nulo');
      setRunPac(reclamo.run_rep ? reclamo.run_rep : 'nulo');
      setPrevPac(reclamo.nombre_aseguradora ? reclamo.nombre_aseguradora : 'nulo');
      setNombrePac(reclamo.nombre_rep ? reclamo.nombre_rep : 'nulo');
      setFecha(reclamo.fechaIngreso ? reclamo.fechaIngreso : 'nulo');
      setEtapa(reclamo.etapa_actual ? reclamo.etapa_actual : 'nulo');
      setNombreCompleto(reclamo.nombre_rec ? reclamo.nombre_rec : 'nulo');
      setRut(reclamo.run_rec ? reclamo.run_rec : 'nulo');
      setMateria(reclamo.materia ? reclamo.materia : 'Sin materia');
      setSubMateria(reclamo.sub_materia ? reclamo.sub_materia : 'Sin sub materia');
      setVia(reclamo.recCtr ? reclamo.recCtr : 'Sin tipo de tramitación');
      /*       setRegion(reclamo.region_rec ? reclamo.region_rec : 'nulo');
      setComuna(reclamo.comuna_rec ? reclamo.comuna_rec : 'nulo'); */
      let data = {
        run: reclamo.run_rec,
        folio: reclamo.n_reclamo ? reclamo.n_reclamo : 'nulo',
      };
      getAdjuntosPorFolio(data);
    }
  }, [reclamo]);

  const getAdjuntosPorFolio = async data => {
    obtenerAdjuntosIfPorFolio(data)
      .then(r => {
        setAdjuntosPrestador(r.data);
      })
      .catch(e => {
        console.error(e);
      })
      .finally(e => {
        setLoading(false);
      });
  };

  const onCloseDialog = event => {
    setLoading(true);
    setValue(0);
    close();
  };

  const viewDetalles = () => {
    return (
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
        <GridContainer style={{ fontSize: 16, fontFamily: 'Roboto' }}>
          <Grid item xs={12} sm={6}>
            <p style={{ backgroundColor: 'lightgray' }}>Nombre Reclamante:</p>
            <p>{nombreCompleto}</p>
          </Grid>
          <Grid item xs={12} sm={6}>
            <p style={{ backgroundColor: 'lightgray' }}>RUT Reclamante:</p>
            <p>{rut}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <p style={{ backgroundColor: 'lightgray' }}>Nombre del representante:</p>
            <p>{nombrePac}</p>
          </Grid>
          <Grid item xs={12} sm={6}>
            <p style={{ backgroundColor: 'lightgray' }}>RUT del representante:</p>
            <p>{runPac}</p>
          </Grid>
          <Grid item xs={12} sm={6}>
            <p style={{ backgroundColor: 'lightgray' }}>Isapre o Fonasa:</p>
            <p>{prevPac}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <p style={{ backgroundColor: 'lightgray' }}>Materia:</p>
            <p>{materia}</p>
          </Grid>
          <Grid item xs={12} sm={6}>
            <p style={{ backgroundColor: 'lightgray' }}>Submateria:</p>
            <p>{subMateria}</p>
          </Grid>
          <Grid item xs={12} sm={6}>
            <p style={{ backgroundColor: 'lightgray' }}>Tipo Tramitación:</p>
            <p>{via}</p>
          </Grid>
        </GridContainer>
      </Box>
    );
  };

  /*   const getHistoryTable = () => {
    const SIZE = 12;
    return (
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            height: 1,
            backgroundColor: 'gray',
            marginBottom: 5,
            marginTop: 5,
          }}
        />
        <Grid item container xs={12} alignItems="center" style={{ backgroundColor: CORP_BLUE, color: 'white' }}>
          <Grid item xs={5} style={{ textAlign: 'center' }}>
            <p style={{ fontSize: SIZE }}>Nombre Adjunto</p>
          </Grid>
          <Grid item xs={2} style={{ textAlign: 'center' }}>
            <p style={{ fontSize: SIZE }}>Subido por</p>
          </Grid>
          <Grid item xs={3} style={{ textAlign: 'center' }}>
            <p style={{ fontSize: SIZE }}>Fecha creación</p>
          </Grid>
          <Grid item xs={2} style={{ textAlign: 'center' }}>
            <p style={{ fontSize: SIZE }}>Adjunto</p>
          </Grid>
        </Grid>
        {reclamo !== null && reclamo !== undefined
          ? reclamo.nom_antecedente.map((item, index) => {
              return (
                <Grid
                  key={index}
                  item
                  container
                  xs={12}
                  alignItems="center"
                  style={{
                    backgroundColor: index % 2 === 0 ? '#ddddee' : 'whitesmoke',
                  }}>
                  <Grid item xs={5} style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: SIZE }}>{item.adjunto}</p>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: SIZE }}>{'nombre usuario' + index}</p>
                  </Grid>
                  <Grid item xs={3} style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: SIZE }}>{'fechasubida' + index}</p>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: SIZE }}>{'estado' + index}</p>
                  </Grid>
                </Grid>
              );
            })
          : null}
        <Grid
          item
          xs={12}
          style={{
            height: 1,
            backgroundColor: 'gray',
            marginBottom: 5,
            marginTop: 5,
          }}
        />
      </Grid>
    );
  }; */

  const viewAdjuntos = () => {
    return (
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
        <Grid container style={{ fontSize: 16, fontFamily: 'Roboto' }}>
          <Grid
            item
            xs={12}
            style={{
              height: 1,
              backgroundColor: 'gray',
              marginBottom: 5,
              marginTop: 5,
            }}
          />
          <ViewHistoriaSuper reclamo={reclamo} setLoading={setLoading} cargarPreviewSuper={cargarPreviewSuper} />
          <Grid
            item
            xs={12}
            style={{
              height: 2,
              backgroundColor: CORP_BLUE,
              marginBottom: 5,
              marginTop: 5,
            }}
          />
          <ViewHistoriaPrestador
            adjuntosPrestador={adjuntosPrestador}
            setLoading={setLoading}
            cargarPreview={cargarPreview}
          />
        </Grid>
      </Box>
    );
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog} fullWidth maxWidth="sm">
      <DialogTitle className={classes.dialogTitleRoot}>
        <label className={classes.num}> Reclamo N° {num} </label>
        <label className={classes.date}> Fecha Ingreso: {fecha} </label>
        <label className={classes.type}> Etapa: {etapa} </label>
      </DialogTitle>
      {loading ? (
        <DialogContent dividers>
          <PageLoader />
        </DialogContent>
      ) : (
        <DialogContent dividers>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Detalle" {...a11yProps(0)} />
                <Tab label="Adjuntos" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              {viewDetalles()}
            </TabPanel>
            <TabPanel value={value} index={1}>
              {viewAdjuntos()}
            </TabPanel>
          </Box>
          <Box display="flex" justifyContent="flex-end" mb={4}>
            {/*           <Button variant="outlined" onClick={() => {}} style={{ marginRight: 10 }}>
            &nbsp;Ver presentación&nbsp;
          </Button> */}
            <Button variant="outlined" color="primary" onClick={onCloseDialog}>
              &nbsp;Cerrar&nbsp;
            </Button>
          </Box>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default VerReclamo;
